module.exports = __webpack_public_path__ + "assets/0c77060187daf21bd57a7c4b391d7249.png";